import _get from 'lodash/get';


const getErrors = state => _get(state, 'siteTexts.errors');
export const getLoadSiteTextsWithConfigError = state => (
  _get(getErrors(state), 'loadSiteTextsWithConfigError')
);
export const getEditSiteTextsError = state => _get(getErrors(state), 'editSiteTextsError');
export const getDeleteSiteTextsError = state => _get(getErrors(state), 'deleteSiteTextsError');
